const SET_IS_LOADING = "NOTIFICATIONS/SET_IS_LOADING";
const SET_ERROR = "NOTIFICATIONS/SET_ERROR";
const SET_PAGE = "NOTIFICATIONS/SET_PAGE";
const RESET = "NOTIFICATIONS/RESET";

const Types = {
  SET_IS_LOADING,
  SET_ERROR,
  SET_PAGE,
  RESET,
};

export default Types;
